import { render, staticRenderFns } from "./SuperTableInit.vue?vue&type=template&id=3829ee36"
import script from "./SuperTableInit.vue?vue&type=script&lang=js"
export * from "./SuperTableInit.vue?vue&type=script&lang=js"
import style0 from "./SuperTableInit.vue?vue&type=style&index=0&id=3829ee36&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports